<template>
  <div class="CCBRecords">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md4>
          <v-card class="mb-2">
            <v-card-title class="title">
              Audios CCB
            </v-card-title>

            <v-card-text v-if="!loading && dataVals.length !== 0">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-text>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                rows-per-page-text="Filas por página:"
              >
                <template slot="items" slot-scope="props">
                  <td :key="props.item.id">{{ props.item.ik_code }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="info"
                      class="mr-2"
                      @click="getItem(props.item)"
                    >
                      audiotrack
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{ itemGetId }}</span>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cerrar</v-btn>
                </v-card-title>

                <v-card-text>
                  Audios Relacionados:
                  <v-divider />

                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in itemGetList"
                      :key="item"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title> {{ index + 1 }}
                          <a :href="item" target="_blank"> {{ item }} </a>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'CCBRecords',

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadRecords()
  },

  data: function () {
    return {
      backConf: {
        path: '/ccb/audios?page=',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,

      search: '',
      dialog: false,
      itemGet: null,
      itemGetId: null,
      itemGetList: null,
      tableKey: 0,

      headers: [
        {
          text: 'Identificador Encuesta',
          value: 'ik_code',
          align: 'left'
        },
        { text: 'Audios Relacionados', value: 'no_audios' }
      ],

      dataVals: []
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      return colVals
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {
    /**
     * Carga la tabla con todos los audios
     */
    loadRecords () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.path + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.loadRecords()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(err => console.error(err))
    },

    getItem (item) {
      this.dialog = true
      this.itemGet = item
      this.itemGetId = item.ik_code
      this.itemGetList = item.audios_list
    },

    close () {
      this.dialog = false
      this.itemGet = null
      this.itemGetId = null
      this.itemGetList = null
    }
  }
}
</script>
